/**
 * Generated by orval v7.9.0 🍺
 * Do not edit manually.
 * Predictions API
 * API documentation for Predictions
 * OpenAPI spec version: 1.24.0
 */

export type WithdrawalResponseDtoStatus = (typeof WithdrawalResponseDtoStatus)[keyof typeof WithdrawalResponseDtoStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const WithdrawalResponseDtoStatus = {
  PENDING: 'PENDING',
  APPROVED: 'APPROVED',
  PROCESSING: 'PROCESSING',
  COMPLETED: 'COMPLETED',
  FAILED: 'FAILED',
  CANCELLED: 'CANCELLED',
  REJECTED: 'REJECTED',
} as const;
